import React from "react";
import { Form, Input, Tooltip } from "antd";

const FormNumericInput = ({
  label,
  name,
  rules,
  placeholder = "Input a number",
  size = "large",
  maxLength = 16,
  form,
  ...rest
}) => {
  const formatNumber = (value) => new Intl.NumberFormat().format(value);

  const handleChange = (e) => {
    const { value: inputValue } = e.target;
    const reg = /^-?\d*(\.\d*)?$/;
    if (reg.test(inputValue) || inputValue === "" || inputValue === "-") {
      form.setFieldsValue({ [name]: inputValue });
    }
  };

  const handleBlur = () => {
    const value = form.getFieldValue(name) || "";
    let valueTemp = value;
    if (value.endsWith(".") || value === "-") {
      valueTemp = value.slice(0, -1);
    }
    form.setFieldsValue({ [name]: valueTemp.replace(/0*(\d+)/, "$1") });
  };

  const title = form.getFieldValue(name) ? (
    <span className="numeric-input-title">
      {form.getFieldValue(name) !== "-"
        ? formatNumber(Number(form.getFieldValue(name)))
        : "-"}
    </span>
  ) : (
    "Input a number"
  );

  const handleKeyPress = (e) => {
    const char = e.key;
    const reg = /^[0-9.\-]$/;
    if (!reg.test(char)) {
      e.preventDefault();
    }
  };

  const handleInput = (e) => {
    const { value: inputValue } = e.target;
    const reg = /^-?\d*(\.\d*)?$/;
    if (!reg.test(inputValue)) {
      const sanitizedValue = inputValue.replace(/[^0-9.\-]/g, "");
      form.setFieldsValue({ [name]: sanitizedValue });
    }
  };

  return (
    <Form.Item label={label} name={name} rules={rules} {...rest}>
        <Input
          placeholder={placeholder}
          size={size}
          maxLength={maxLength}
          onChange={handleChange}
          onKeyPress={handleKeyPress}
          onInput={handleInput}
          onBlur={handleBlur}
          {...rest}
        />
    </Form.Item>
  );
};

export default FormNumericInput;
